"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validator = void 0;
var ZIP_REGEX = /^(\d{5}([-]\d{4})?)$/;
exports.Validator = {
    name: "zip-code",
    errorMessage: "Entered value is in not valid zip code number.",
    validate: function (value) { return ZIP_REGEX.test("".concat(value)); },
};
